import { ChangeSourceType, DocumentChangedInfo, DocumentInfo, FormDocument } from '@formbird/types';
import { Action } from 'redux';

export const FORM_SETUP_DOCUMENT_LIST = 'FORM_SETUP_DOCUMENT_LIST';

export const FORM_UPDATE_DOCUMENT = 'FORM_UPDATE_DOCUMENT';
export const FORM_CHANGE_DOCUMENT = 'FORM_CHANGE_DOCUMENT';
export const FORM_RESET_CHANGE_DOCUMENT = 'FORM_RESET_CHANGE_DOCUMENT';
export const FORM_SET_DOCUMENT = 'FORM_SET_DOCUMENT';
export const FORM_DELETE_DOCUMENT = 'FORM_DELETE_DOCUMENT';
export const FORM_SET_COMPONENT_FLAG_TEMPLATE = 'FORM_SET_COMPONENT_FLAG_TEMPLATE';
export const FORM_CLEAR_DOCUMENT = 'FORM_CLEAR_DOCUMENT';
export const FORM_RESET_TO_ORG_DOCUMENT = 'FORM_RESET_TO_ORG_DOCUMENT';

export const FORM_SET_ORG_DOCUMENT = 'FORM_SET_ORG_DOCUMENT';

export const FORM_SET_DOCUMENT_INFO = 'FORM_SET_DOCUMENT_INFO';
export const FORM_RESET_DOCUMENT_INFO = 'FORM_RESET_DOCUMENT_INFO';

export const FORM_UNDO = 'FORM_UNDO';
export const FORM_REDO = 'FORM_REDO';
export const FORM_RESET_UNDO_REDO = 'FORM_RESET_UNDO_REDO';

export const FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT = 'FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT';
export const FORM_SET_DOCUMENT_SESSION = 'FORM_SET_DOCUMENT_SESSION';

/**
 * Document List section
 */
export interface IFormSetupDocumentListAction extends Action {
  payload: {
    documentListId: string,
    isMainDoc: boolean
  };
}

export function formSetupDocumentList(documentListId: string, isMainDoc: boolean): IFormSetupDocumentListAction {
  return {
    type: FORM_SETUP_DOCUMENT_LIST,
    payload: {
      documentListId,
      isMainDoc
    }
  };
}

/**
 * Change document section
 */
export interface IFormDocumentChangedAction extends Action {
  payload: {
    documentChangedInfo: DocumentChangedInfo
  };
}

export function formDocumentUpdated(documentChangedInfo: DocumentChangedInfo): IFormDocumentChangedAction {
  return {
    type: FORM_UPDATE_DOCUMENT,
    payload: {
      documentChangedInfo
    }
  };
}

export function formDocumentChanged(documentChangedInfo: DocumentChangedInfo): IFormDocumentChangedAction {
  return {
    type: FORM_CHANGE_DOCUMENT,
    payload: {
      documentChangedInfo
    }
  };
}

export interface IFormResetDocumentChangedAction extends Action {
}

export function formResetDocumentChanged(): IFormResetDocumentChangedAction {
  return {
    type: FORM_RESET_CHANGE_DOCUMENT
  };
}

/**
 * Clear document section
 */
export interface IFormClearDocumentsAction extends Action {
}

export function formClearDocuments(): IFormClearDocumentsAction {
  return {
    type: FORM_CLEAR_DOCUMENT
  };
}

/**
 * Set document section
 */
export interface IFormSetDocumentAction extends Action {
  payload: {
    document: FormDocument;
    versionId?: string;
    source?: ChangeSourceType;
  };
}

export interface IFormDeleteDocumentAction extends Action {
  payload: {
    documentId: string;
  };
}

export interface IFormSetComponentFlagAction extends Action {
  payload: {
    templateId: string;
    fieldName: string;
    flagName: string;
    flagValue: any;
    source?: ChangeSourceType
  };
}

export interface IFormResetToOrgDocumentAction extends Action {
  payload: {
    documentId: string
  }
}

export function formSetDocument(document: FormDocument, versionId?: string): IFormSetDocumentAction {
  return {
    type: FORM_SET_DOCUMENT,
    payload: {
      document,
      versionId
    }
  };
}

export function formSetComponentFlagTemplate(templateId, fieldName, flagName, flagValue): IFormSetComponentFlagAction {
  return {
    type: FORM_SET_COMPONENT_FLAG_TEMPLATE,
    payload: {
      templateId,
      fieldName,
      flagName,
      flagValue
    }
  };
}

export function formSetOrgDocument(document: FormDocument, versionId?: string): IFormSetDocumentAction {
  return {
    type: FORM_SET_ORG_DOCUMENT,
    payload: {
      document,
      versionId
    }
  };
}

export function formDeleteDocument(documentId: string): IFormDeleteDocumentAction {
  return {
    type: FORM_DELETE_DOCUMENT,
    payload: {
      documentId
    }
  };
}

export function formResetToOrgDocument(documentId: string): IFormResetToOrgDocumentAction {
  return {
    type: FORM_RESET_TO_ORG_DOCUMENT,
    payload: {
      documentId
    }
  };
}

/**
 * Document info section
 */
export interface IFormSetDocumentInfoAction extends Action {
  payload: {
    unsavedDocumentListId: string,
    documentInfo: DocumentInfo
  }
}

export function formSetDocumentInfo(documentListId: string, documentInfo: DocumentInfo): IFormSetDocumentInfoAction {
  return {
    type: FORM_SET_DOCUMENT_INFO,
    payload: {
      documentInfo,
      unsavedDocumentListId: documentListId
    }
  };
}

export interface IFormResetDocumentInfoAction extends Action {
  payload: {
    unsavedDocumentListId: string
  }
}

export function formResetDocumentInfo(unsavedDocumentListId: string): IFormResetDocumentInfoAction {
  return {
    type: FORM_RESET_DOCUMENT_INFO,
    payload: {
      unsavedDocumentListId
    }
  };
}

/**
 * Undo/Redo document section
 */

export interface IFormUndoDocumentAction extends Action {
}

export interface IFormRedoDocumentAction extends Action {
}

export interface IFormResetUnRedoDocumentAction extends Action {
}

export function formUndoDocument(): IFormUndoDocumentAction {
  return {
    type: FORM_UNDO
  };
}

export function formRedoDocument(): IFormRedoDocumentAction {
  return {
    type: FORM_REDO
  };
}

export function resetUndoRedoDocument(): IFormResetUnRedoDocumentAction {
  return {
    type: FORM_RESET_UNDO_REDO
  };
}

export interface IFormSetDisabledSaveAction extends Action {
  payload: {
    documentId: string;
    disabledFields: any;
  };
}

export function formSetDisableSaveFieldDocument(documentId: string, disabledFields: any): IFormSetDisabledSaveAction {
  return {
    type: FORM_SET_DISABLE_SAVE_FIELD_DOCUMENT,
    payload: {
      documentId,
      disabledFields
    }
  };
}


export interface IFormSetDocumentSessionAction extends Action {
  payload: {
    documentSession: any;
    documentId: string;
  };
}

export function formSetDocumentSession(documentSession: any, documentId: string): IFormSetDocumentSessionAction {
  return {
    type: FORM_SET_DOCUMENT_SESSION,
    payload: {
      documentSession,
      documentId
    }
  };
}
